<template>
  <div class="container">
    <PublicHeader :totalName="$t('trade').buyBtn + ' ' + SalesTemplateInfo.currency" />
    <!-- 单价 -->
    <div class="tit">{{ $t('c2c').price }} <span>{{ price }} {{ Currency }}</span></div>
    <!-- 选择币种 -->
    <div class="selInfo" @click="showPopover = true">
      <div class="left">
        <div class="symbolInfo">{{ Symbol }}</div>
        <div class="name">
          <div class="t1">{{ Currency }}</div>
        </div>
      </div>
      <van-icon name="play" size="13" class="ric" color="var(--primary_color)" />
    </div>
    <PopupSelect :title="$t('bill').Currency" v-model="showPopover" :selectList="RateList" :selectedValue="rate" :onSelect="onSelect" />
    <!-- 数量 -->
    <div class="numInfo">
      <van-field v-model="quantity" type="number" clearable @input="onInput" :placeholder="$t('recharge').amountMsg">
        <template #right-icon>
          <span style="color: var(--ntext_color)">{{ SalesTemplateInfo.currency }}</span>
        </template>
      </van-field>
    </div>
    <!-- 限额 -->
    <div class="lables">{{ $t('c2c').limit }}<span>{{ SalesTemplateInfo.lowAmount }} &#8209; {{ SalesTemplateInfo.highAmount
    }} {{
          SalesTemplateInfo.currency }}</span></div>
    <!-- 可用 -->
    <div class="lables">{{ $t('c2c').available }}<span>{{ SalesTemplateInfo.usableAmount }} {{
      SalesTemplateInfo.currency }}</span></div>
    <div class="bottomInfo">
      <!-- 您需支付 -->
      <div class="tips">{{ $t('c2c').needpay }}<span>{{ amount }} {{ Currency }}</span></div>
      <!-- 您将获得 -->
      <div class="tips">{{ $t('c2c').willreceive }}<span>{{ quantity }} {{ SalesTemplateInfo.currency }}</span></div>
      <!-- 按钮 -->
      <van-button block :loading="btnloading" @click="handleSub">{{ $t('public').confirm }}</van-button>
    </div>

  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import productApi from '@/api/product'
import orderApi from '@/api/order'
import chatApi from '@/api/chat'
import PublicHeader from '@/components/publicHeader'
import PopupSelect from '@/components/popupSelect.vue'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    PublicHeader,
    PopupSelect,
  },
  data() {
    return {
      btnloading: false,
      SalesTemplateInfo: {},
      quantity: '',
      amount: '',
      AssetBalance: 0,
      vendorSalesTemplateId: '',
      showPopover: false,
      RateList: [],
      rate: 1,
      price: '',
      Currency: 'USD',
      Symbol: '$',
    }
  },
  async mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    this.getRateList()
    this.vendorSalesTemplateId = this.$route.query.id
    this.getSalesTemplateInfo()
  },
  methods: {
    // 选择币种
    async onSelect(action) {
      this.Currency = action.text
      this.Symbol = action.symbol
      this.rate = action.val
      this.price = this.rate * this.SalesTemplateInfo.price
      this.showPopover = false
      if (this.quantity)
        this.onInput()
    },
    // 获取货币汇率
    async getRateList() {
      const res = await systemApi.getRateList()
      this.RateList = res.rate
    },
    //查询C2C供应商销售模板详情数据
    async getSalesTemplateInfo() {
      const res = await productApi.getSalesTemplateInfo({ id: this.vendorSalesTemplateId })
      this.SalesTemplateInfo = res.data
      this.price = this.rate * this.SalesTemplateInfo.price
    },
    //金额输入
    onInput() {
      if (this.quantity) {
        this.amount = (this.quantity * this.price).toFixed(6).replace(/\.?0+$/, '')
      }
    },
    // 提交
    async handleSub() {
      if (!this.quantity) {
        this.$toast(this.$t('recharge').amountMsg)
        return false
      }
      //不足限额
      if (this.quantity < this.SalesTemplateInfo.lowAmount) {
        this.$toast(this.$t('c2c').Insufficientlimit)
        return false
      }
      //超出限额
      if (this.quantity > this.SalesTemplateInfo.highAmount) {
        this.$toast(this.$t('c2c').Exceedinglimit)
        return false
      }
      //超出可用
      if (this.quantity > this.SalesTemplateInfo.usableAmount) {
        this.$toast(this.$t('c2c').Exceedingavailable)
        return false
      }
      const form = {
        vendorSalesTemplateId: this.vendorSalesTemplateId,
        quantity: this.quantity,
        price: this.price,
        legalCurrency: this.Currency,
      }
      this.btnloading = true
      const res = await orderApi.buyCtcOrder(form)
      this.btnloading = false
      //发送消息
      var msg = {
        tradeId: res.data.ctcOrderId,
        content: `orderNo: ${res.data.orderNo}\ntype: Buy \ncurrency: ${res.data.currency} \nprice: ${res.data.price} ${res.data.legalCurrency} \nquantity: ${res.data.quantity} \namount: ${res.data.amount} ${res.data.legalCurrency}`,
        contentType: '1'
      }
      await chatApi.creatTalkItem(msg)
      this.$toast({ message: this.$t('recharge').subMsg })
      this.$router.push({ name: 'Chat', query: { id: res.data.ctcOrderId } })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 50px 15px 0 15px;
  background: var(--background_color);

  .tit {
    margin-bottom: 15px;
    text-align: center;
    font-size: 14px;
    color: var(--ntext_color);

    span {
      color: var(--text_color);
    }
  }

  .ric {
    transform: rotate(90deg);
  }

  .selInfo {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid var(--info_color);
    border-radius: 10px;
    padding: 15px;

    .left {
      display: flex;
      align-items: center;

      .symbolInfo {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: var(--primary_color);
        color: #fff;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .name {
        margin-left: 10px;

        .t1 {
          font-size: 16px;
          font-weight: bold;
          color: var(--primary_color);
        }

        .t2 {
          margin-top: 10px;
          font-size: 13px;
          color: var(--ntext_color);
        }
      }
    }
  }

  .lables {
    margin-top: 15px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: var(--ntext_color);

    span {
      margin-left: 10px;
      color: var(--text_color);
    }
  }

  .bottomInfo {
    margin-top: 50px;

    .tips {
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      color: var(--ntext_color);

      span {
        margin-left: 10px;
        color: var(--text_color);
        font-weight: bold;
      }
    }

    .van-button {
      background: var(--primary_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: #fff;
    }
  }
}

.itemss {
  padding: 15px;
  font-size: 14px;
  color: var(--text_color);
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

.van-cell {
  background: var(--background_color);
  border: 1px solid var(--info_color);
  height: 50px;
  padding: 10px;
  border-radius: 10px;
  font-size: 20px;
  font-weight: bold;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__right-icon {
  margin: -10px 8px;
  padding: 0px;
  line-height: normal;
  font-size: 15px;
}
</style>
